import { getModalById, PLATE_CHANGE_PASSWORD, PlateTemplate } from '#/features/modals'
import styles from './change-password.module.scss'
import { CommonButton } from '#/shared/ui/button'
import { CommonInput } from '#/shared/ui/common-input'
import { useChangePassword } from '../lib/use-change-password'
import OpenedEyeSvg from '#/assets/svg/opened-eye.svg?react'
import ClosedEyeSvg from '#/assets/svg/closed-eye.svg?react'

export const ChangePasswordPlate = () => {
	const modal = getModalById(PLATE_CHANGE_PASSWORD)

	const { onSubmit, register, errors, reset, trigger, passwordShowed, setPasswordShowed } = useChangePassword()

	return (
		<PlateTemplate id={PLATE_CHANGE_PASSWORD} headerClassName={styles.container} variant='secondary' closeModal={() => reset()}>
			<form className={styles.modal} onChange={() => trigger()} onSubmit={onSubmit}>
				<p className={styles.modal__header}>Смена пароля</p>
				<div className={styles.box}>
					<CommonInput
						{...register('password', {
							required: 'Обязательное поле',
							minLength: { value: 6, message: 'Укажите пароль не меньше 6 символов' },
						})}
						label='Новый пароль'
						variant='outline'
						placeholder='Пароль'
						autoComplete='new-password'
						error={errors.password}
						type={passwordShowed ? '' : 'password'}
						rightSlot={
							<button type='button' onClick={() => setPasswordShowed((prev) => !prev)}>
								{passwordShowed ? (
									<ClosedEyeSvg width={24} height={24} color='grey' />
								) : (
									<OpenedEyeSvg width={24} height={24} color='grey' />
								)}
							</button>
						}
					/>
					<CommonInput
						{...register('newPassword', {
							required: 'Обязательное поле',
							minLength: { value: 6, message: 'Укажите пароль не меньше 6 символов' },
						})}
						label='Повторить пароль'
						variant='outline'
						placeholder='Повторить пароль'
						type={passwordShowed ? '' : 'password'}
						rightSlot={
							<button type='button' onClick={() => setPasswordShowed((prev) => !prev)}>
								{passwordShowed ? (
									<ClosedEyeSvg width={24} height={24} color='grey' />
								) : (
									<OpenedEyeSvg width={24} height={24} color='grey' />
								)}
							</button>
						}
						error={errors.newPassword}
					/>
				</div>
				<div className={styles.modal__buttons}>
					<CommonButton variant='primary' type='submit'>
						Сменить пароль
					</CommonButton>
					<CommonButton variant='gray' onClick={() => modal.setState(false)} type='button'>
						Отмена
					</CommonButton>
				</div>
			</form>
		</PlateTemplate>
	)
}
